import { createDemoStep } from '@interhyp/platform-demo';
export const PORTAL_OPEN_FINANCING_PAGE = createDemoStep({
    id: 'portal-open-financing-page',
    description: 'Wechseln Sie auf den Finanzierungsreiter, um unterschiedliche Finanzierungsmöglichkeiten zu vergleichen.',
});
